import { Button } from '@/components/Button/Button'
import { GeneratorPopup } from '@/components/Generator/GeneratorPopup/GeneratorPopup'
import { QuotaPopup } from '@/components/QuotaPopup/QuotaPopup'
import { UserMenu } from '@/components/UserMenu/UserMenu'
import GitHubSvg from '@/icons/github.svg?react'
import { useAuthState } from '@/state/auth'
import { useUserState } from '@/state/user'
import type { FunctionalComponent } from 'preact'
import { useLocation } from 'preact-iso'
import { useState } from 'preact/hooks'
import styles from './index.module.scss'

export const Header: FunctionalComponent = () => {
  const user = useUserState(s => s.user)
  const quota = useUserState(s => s.quota)
  const token = useAuthState(s => s.token)
  const { url } = useLocation()

  const [generatorVisible, setGeneratorVisible] = useState(false)
  const [quotaVisible, setQuotaVisible] = useState(false)

  return (
    <>
      {generatorVisible && (
        <GeneratorPopup
          onClose={() => {
            setGeneratorVisible(false)
          }}
        />
      )}

      {quotaVisible && (
        <QuotaPopup
          onClose={() => {
            setQuotaVisible(false)
          }}
        />
      )}

      <div class={styles.root}>
        <div class={styles.main}>
          <div class={styles.logo}>
            gitlog
          </div>

          {token && (
            <>
              <a href='/' class={url === '/' ? styles.active : undefined}>
                repos
              </a>
              <a href='/posts' class={url === '/posts' ? styles.active : undefined}>
                posts
              </a>
            </>
          )}
        </div>

        <div class={styles.menu}>
          {token
            ? (
              user
                ? (
                  <>
                    <Button
                      size='s'
                      type='primary'
                      onClick={() => {
                        if (!quota) return
                        if (quota.remaining > 0) {
                          setGeneratorVisible(true)
                        }
                        else {
                          setQuotaVisible(true)
                        }
                      }}
                    >
                      make
                      <span class='hide-sm'>
                        {' '}
                        post
                      </span>
                    </Button>

                    {quota && (
                      <Button
                        size='s'
                        onClick={() => {
                          setQuotaVisible(true)
                        }}
                      >
                        {quota?.remaining}
                        <span class='hide-sm'>
                          {' '}
                          left
                        </span>
                      </Button>
                    )}

                    <UserMenu
                      username={user.githubLogin}
                      avatarUrl={user.avatarUrl}
                    />
                  </>
                )
                : null
            )
            : (
              <Button
                size='s'
                type='primary'
                href='/api/auth/github'
                target='_top'
              >
                <GitHubSvg class={styles.githubSvg} />
                Login
              </Button>
            )}
        </div>
      </div>
    </>
  )
}
